import axios from 'axios';

import getUrl from 'utils/getUrl';
import { generateApiError } from './utils/apiErrorMessages';
import { SURVEY_TYPE_COLLECTION_PATH } from './config/EntityCollectionPathMap';

const removePostSurveyLogicRule = ({ surveyId, ruleId }) =>
  axios
    .delete(
      getUrl.apiV2(
        `${SURVEY_TYPE_COLLECTION_PATH}/${surveyId}/item/rules/${ruleId}`,
      ),
    )
    .catch(generateApiError());

export default removePostSurveyLogicRule;
